/**
 * Generated by orval v6.17.0 🍺
 * Do not edit manually.
 * Gatti Filtrazioni
 * OpenAPI spec version: v1
 */
import axios from "axios";
import type { AxiosRequestConfig, AxiosResponse, AxiosError } from "axios";
import { useQuery, useMutation } from "@tanstack/react-query";
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey,
} from "@tanstack/react-query";
import type { RolePermissionDto } from ".././models";

export const getApiRolePermission = (
  options?: AxiosRequestConfig
): Promise<AxiosResponse<RolePermissionDto[]>> => {
  return axios.get(`/api/RolePermission`, options);
};

export const getGetApiRolePermissionQueryKey = () =>
  [`/api/RolePermission`] as const;

export const getGetApiRolePermissionQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiRolePermission>>,
  TError = AxiosError<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getApiRolePermission>>,
    TError,
    TData
  >;
  axios?: AxiosRequestConfig;
}): UseQueryOptions<
  Awaited<ReturnType<typeof getApiRolePermission>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiRolePermissionQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiRolePermission>>
  > = ({ signal }) => getApiRolePermission({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions };
};

export type GetApiRolePermissionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiRolePermission>>
>;
export type GetApiRolePermissionQueryError = AxiosError<unknown>;

export const useGetApiRolePermission = <
  TData = Awaited<ReturnType<typeof getApiRolePermission>>,
  TError = AxiosError<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getApiRolePermission>>,
    TError,
    TData
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetApiRolePermissionQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const putApiRolePermission = (
  rolePermissionDto: RolePermissionDto[],
  options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
  return axios.put(`/api/RolePermission`, rolePermissionDto, options);
};

export const getPutApiRolePermissionMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiRolePermission>>,
    TError,
    { data: RolePermissionDto[] },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiRolePermission>>,
  TError,
  { data: RolePermissionDto[] },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiRolePermission>>,
    { data: RolePermissionDto[] }
  > = (props) => {
    const { data } = props ?? {};

    return putApiRolePermission(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiRolePermissionMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiRolePermission>>
>;
export type PutApiRolePermissionMutationBody = RolePermissionDto[];
export type PutApiRolePermissionMutationError = AxiosError<unknown>;

export const usePutApiRolePermission = <
  TError = AxiosError<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiRolePermission>>,
    TError,
    { data: RolePermissionDto[] },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationOptions = getPutApiRolePermissionMutationOptions(options);

  return useMutation(mutationOptions);
};

export const __$$useGetApiRolePermission = () =>
  //@ts-ignore
  useGetApiRolePermission(...([] as any[]));

export const __$$usePutApiRolePermission = () =>
  //@ts-ignore
  usePutApiRolePermission(...([] as any[]));
